(ns ui.editor2.modal-exit
  "Modal Dialog for exiting the editor2. This will be shown if there are unsaved
  changes in the editor.")

(defn panel
  [state]
  [:div.flex.items-center.justify-center.flex-col
   {:replicant/key :exit}
   [:div.flex.items-center
    [:div.relative.transform.overflow-hidden.bg-white.px-4.pb-4.pt-5.text-left.transition-all.sm:my-8.sm:w-full.sm:max-w-lg.sm:p-6
     [:div.sm:flex.sm:items-start
      [:div.mx-auto.flex.size-12.shrink-0.items-center.justify-center.rounded-full.bg-red-100.sm:mx-0.sm:size-10
       [:svg.size-6.text-red-600 {:fill "none" :viewBox "0 0 24 24" :stroke-width "1.5" :stroke "currentColor" :aria-hidden "true" :data-slot "icon"}
        [:path {:stroke-linecap "round" :stroke-linejoin "round" :d "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"}]]]
      [:div.mt-3.text-center.sm:ml-4.sm:mt-0.sm:text-left
       [:h3#modal-title.text-base.font-semibold.text-gray-900
        "Review Changes!"]
       [:div.mt-2
        [:p.text-sm.text-gray-500
         "Your Story has unsaved changes. Are you sure you want to discard changes."]]]]
     [:div.mt-5.sm:mt-4.sm:flex.sm:flex-row-reverse
      [:button.inline-flex.w-full.justify-center.rounded-md.bg-red-600.px-3.py-2.text-sm.font-semibold.text-white.shadow-sm.hover:bg-red-500.sm:ml-3.sm:w-auto
       {:type "button"
        :on {:click [[:ui/modal-close]
                     [:editor2/exit true]]}}
       "Discard changes"]
      [:button.mt-3.inline-flex.w-full.justify-center.rounded-md.bg-white.px-3.py-2.text-sm.font-semibold.text-gray-900.shadow-sm.ring-1.ring-inset.ring-gray-300.hover:bg-gray-50.sm:mt-0.sm:w-auto
       {:type "button"
        :on {:click [[:ui/modal-close]]}}
       "Continue editing"]]]]])

(defn render [state]
  [:div
   (panel state)])

(def modal
  {:modal-id :modal/exit
   :on-load (fn [_location]
              [[]])
   :render #'render})